export default __webpack_public_path__ + "static/media/whitetail.4990e1d0.png";